import React from 'react';
import _ from "lodash"

const DiagAPCMProgramDetailCell = ({data}) => {
       
        const programType = data.program_type;
        let programTypeLabel = '-'
        if(programType === 'ccm'){
                programTypeLabel = 'CCM'
        }else if(programType === 'apcm'){
                programTypeLabel = 'APCM';
        }
        return <div>
                <div style={{fontWeight:600}}>
                       Active Program : {programTypeLabel}
                </div>
                {
                        <div className="value-box" style={{ width: "100%", display:'flex', flex:1, flexDirection:'column', padding:0}}>
                               
                               {
                                programType === 'apcm' &&  <div style={{display:'flex',justifyContent:'flex-start', padding:0}}>
                                        <span style={{fontWeight:400}}>APCM Service Level:</span>
                                        <span style={{paddingLeft:15}}>{data.apcm_service_level ? data.apcm_service_level : '-'}</span>
                                </div>
                               }
                               
                               
                        
                    </div> 

                }
                
               
        </div>
};

export default DiagAPCMProgramDetailCell;
